// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { change, touch } from 'redux-form'
import { AFS_GRID_RESULTS } from 'redux/modules/interferenceAnalysis/constants'
import getAllVisiblePathIds from 'redux/modules/interferenceAnalysis/thunks/getAllVisiblePathIds'

const deactivateVisiblePolarizations = () => (dispatch, getState) => {
  const visiblePathIds = dispatch(getAllVisiblePathIds())
  const { values } = getState().form[AFS_GRID_RESULTS]

  visiblePathIds.forEach(pathId => {
    // the prefix `path_id_` is because of a convention
    // which is defined in parseAnalysisResults.js
    const pathName = `path_id_${pathId}`
    const pathChannels = values[pathName]

    const changedFields = []
    const deactivatedChannels = Object.keys(pathChannels).reduce((a, channelKey, i) => {
      if (pathChannels[channelKey] !== 0) {
        changedFields.push(`${pathName}.${channelKey}`)
      }
      a[channelKey] = 0
      return a
    }, {})

    dispatch(change(
      AFS_GRID_RESULTS,
      pathName,
      deactivatedChannels,
    ))
    dispatch(touch(AFS_GRID_RESULTS, ...changedFields))
  })
}

export default deactivateVisiblePolarizations
